import { isNil } from "lodash";
import { formatBorrowerObjectFullName } from "../functions/formatBorrowerObjectFullName";

export const formatBorrowersArray = (borrowers) => {
  if (!borrowers) return "N/A";
  if (Array.isArray(borrowers)) {
    return borrowers
      .map((borrower) =>
        isNil(borrower) ? "N/A" : formatBorrowerObjectFullName(borrower),
      )
      .join(", ");
  }
  return borrowers;
};
